import { useLocalization } from "@tm/localization"
import { useActions } from "@tm/morpheus"
import { useCallback, useMemo } from "react"
import { useSelector } from "react-redux"
import GeneralMainFields from "@bundles/damage-calculation-dat/components/_shared/GeneralMainFields"
import { createSelector } from "reselect"
import { getAswegasMainSchema } from "../../../data/helpers"
import { RepairCoverages } from "../../../data/models"
import { MainActions } from "../../main/business"
import { MainState } from "../../main"

const summaryMainFieldsSelector = createSelector(
    (state: MainState) => state.summary.fields,
    (fields) => ({
        processName: fields.processName,
        repairCoverage: fields.repairCoverage,
    })
)

export default function MainFields() {
    const { translateText, languageId } = useLocalization()
    const actions = useActions(MainActions, "updateFieldValue", "setValidateFields")
    const fields = useSelector(summaryMainFieldsSelector)

    const aswegasSchema = useMemo(() => getAswegasMainSchema(translateText), [translateText])

    const repairScopes = useMemo<Record<RepairCoverages, string>>(
        () => ({
            0: translateText(12470),
            1: translateText(12471),
        }),
        [languageId]
    )

    const handleUpdateCoverageField = useCallback(
        (value: string) => {
            const key = Object.keys(repairScopes).find((x) => repairScopes[x as RepairCoverages] === value)
            actions.updateFieldValue("repairCoverage", key ?? value)
        },
        [repairScopes, actions]
    )

    const handleFormValid = useCallback(
        (isValid: boolean) => {
            actions.setValidateFields("mainValid", isValid)
        },
        [actions]
    )

    const onHandleUpdateValue = useCallback(
        (path: string, value: string) => {
            actions.updateFieldValue(path, value)
        },
        [actions]
    )

    return (
        <GeneralMainFields
            repairScopes={repairScopes}
            fields={fields}
            schema={aswegasSchema}
            onFormValid={handleFormValid}
            onUpdateCoverageField={handleUpdateCoverageField}
            onUpdateFieldValue={onHandleUpdateValue}
        />
    )
}
